import { RecordsModel } from 'app/services/records/record-resource.service';

export function getRefNum(record: RecordsModel) {
    return record.prefix + record.id;
}
